export default __webpack_public_path__ + "static/media/algorithms.8818fb09.PNG";